module.exports = __webpack_public_path__ + "img/Jimmy-modal.493d0c4e.png";